(function tooltipDirective($, Adzuki)
{
    'use strict';

    function toPopperPlacement(input) {
        const p = String(input || '').trim();
        return p || 'top';
    }

    function parseTriggers(input) {
        const raw = String(input || 'hover focus').trim();
        if (!raw) {
            return [];
        }
        return raw.split(/\s+/g).filter(Boolean);
    }

    function setNodeContent(node, value, allowHtml) {
        const v = (value === null || value === undefined) ? '' : String(value);

        if (allowHtml) {
            node.innerHTML = v;
        } else {
            node.textContent = v;
        }
    }

    function isEventInside(event, el, tip) {
        const t = event.target;
        return Boolean((el && el.contains(t)) || (tip && tip.contains(t)));
    }

    function getBootstrapSideFromPopperPlacement(popperPlacement) {
        const placement = String(popperPlacement || '');
        const base = placement.split('-')[0];

        if (base === 'left') {
            return 'start';
        }
        if (base === 'right') {
            return 'end';
        }
        return base;
    }

    function syncBootstrapPlacementClasses(tip, popperInstance, type) {
        if (!tip || !popperInstance || !popperInstance.state) {
            return;
        }

        const bsSide = getBootstrapSideFromPopperPlacement(popperInstance.state.placement);

        tip.classList.remove(
            'bs-tooltip-top', 'bs-tooltip-bottom', 'bs-tooltip-start', 'bs-tooltip-end',
            'bs-popover-top', 'bs-popover-bottom', 'bs-popover-start', 'bs-popover-end'
        );

        if (type === 'popover') {
            tip.classList.add('bs-popover-' + bsSide);
        } else {
            tip.classList.add('bs-tooltip-' + bsSide);
        }
    }

    const vPopperTooltip = {
        mounted(el, binding) {
            const opts = (typeof binding.value === 'string')
                ? { content: binding.value }
                : (binding.value || {});

            const type = String(opts.type || el.getAttribute('data-popper-type') || 'tooltip').toLowerCase();

            const allowHtml = Boolean(
                opts.html ||
                opts.allowHtml ||
                (el.getAttribute('data-html') === 'true')
            );

            const trigger = opts.trigger || el.getAttribute('data-trigger') || 'hover focus';
            const triggers = parseTriggers(trigger);

            const title = opts.title ||
                el.getAttribute('data-title') ||
                el.getAttribute('data-bs-title') ||
                '';

            const content = opts.content ||
                el.getAttribute('data-content') ||
                el.getAttribute('title') ||
                '';

            const placementRaw = opts.placement ||
                el.getAttribute('data-placement') ||
                el.getAttribute('data-bs-placement') ||
                'top';

            const placement = toPopperPlacement(placementRaw);

            const offset = Array.isArray(opts.offset) ? opts.offset : [0, 8];

            const useBootstrapPlacementClasses = (opts.bootstrapPlacementClasses && opts.bootstrapPlacementClasses !== undefined)
                ? Boolean(opts.bootstrapPlacementClasses)
                : true;

            const closeOnOutsideClick = (opts.closeOnOutsideClick)
                ? Boolean(opts.closeOnOutsideClick)
                : (triggers.indexOf('click') !== -1);

            const closeOnEsc = (opts.closeOnEsc && opts.closeOnEsc !== undefined)
                ? Boolean(opts.closeOnEsc)
                : true;

            // Preserve/disable native browser tooltip
            el._originalTitle = el.getAttribute('title');
            el.removeAttribute('title');

            // Build tooltip/popover DOM (Bootstrap 5 classes)
            const tip = document.createElement('div');
            tip.setAttribute('role', 'tooltip');
            tip.style.position = 'absolute';
            tip.style.zIndex = '1080';
            tip.style.display = 'none';

            const tipId = 'popper_' + Math.random().toString(36).slice(2);
            tip.id = tipId;

            if (type === 'popover') {
                tip.className = 'popover fade';
                tip.innerHTML = `
                    <div class="popover-arrow" data-popper-arrow></div>
                    ${title ? `<h3 class="popover-header"></h3>` : ``}
                    <div class="popover-body"></div>
                `;

                if (title) {
                    setNodeContent(tip.querySelector('.popover-header'), title, allowHtml);
                }
                setNodeContent(tip.querySelector('.popover-body'), content, allowHtml);
            } else {
                tip.className = 'tooltip fade';
                tip.innerHTML = `
                    <div class="tooltip-arrow" data-popper-arrow></div>
                    <div class="tooltip-inner"></div>
                `;
                setNodeContent(tip.querySelector('.tooltip-inner'), content, allowHtml);
            }

            document.body.appendChild(tip);

            el.setAttribute('aria-describedby', tipId);

            const popper = window.Popper.createPopper(el, tip, {
                placement: placement,
                modifiers: [
                    {
                        name   : 'offset',
                        options: { offset: offset }
                    },
                    {
                        name   : 'preventOverflow',
                        options: {
                            padding: 8
                        }
                    },
                    {
                        name   : 'arrow',
                        options: {
                            element: tip.querySelector('[data-popper-arrow]')
                        }
                    }
                ],
                onFirstUpdate: () => {
                    if (useBootstrapPlacementClasses) {
                        syncBootstrapPlacementClasses(tip, popper, type);
                    }
                }
            });

            let isShown = false;

            const show = () => {
                if (isShown) {
                    return;
                }
                isShown = true;

                tip.style.display = 'block';
                tip.classList.add('show');

                popper.update().then(() => {
                    if (useBootstrapPlacementClasses) {
                        syncBootstrapPlacementClasses(tip, popper, type);
                    }
                });
            };

            const hide = () => {
                if (!isShown) {
                    return;
                }
                isShown = false;

                tip.classList.remove('show');
                tip.style.display = 'none';
            };

            const toggle = () => {
                if (isShown) {
                    hide();
                } else {
                    show();
                }
            };

            // Handlers (kept as named consts so we can remove them)
            const onMouseEnter = () => { show(); };
            const onMouseLeave = () => { hide(); };
            const onFocus = () => { show(); };
            const onBlur = () => { hide(); };
            const onClick = (e) => {
                if (opts.preventDefaultOnClick) {
                    e.preventDefault();
                }
                toggle();
            };

            const onDocumentPointerDown = (e) => {
                if (!closeOnOutsideClick) {
                    return;
                }
                if (!isShown) {
                    return;
                }
                if (isEventInside(e, el, tip)) {
                    return;
                }
                hide();
            };

            const onDocumentKeyDown = (e) => {
                if (!closeOnEsc) {
                    return;
                }
                if (!isShown) {
                    return;
                }
                if (e.key === 'Escape' || e.key === 'Esc') {
                    hide();
                }
            };

            // Wire triggers similar to Bootstrap
            if (triggers.indexOf('hover') !== -1) {
                el.addEventListener('mouseenter', onMouseEnter);
                el.addEventListener('mouseleave', onMouseLeave);
            }
            if (triggers.indexOf('focus') !== -1) {
                el.addEventListener('focus', onFocus);
                el.addEventListener('blur', onBlur);
            }
            if (triggers.indexOf('click') !== -1) {
                el.addEventListener('click', onClick);
            }

            // Global close behaviors
            document.addEventListener('pointerdown', onDocumentPointerDown, true);
            document.addEventListener('keydown', onDocumentKeyDown, true);

            // Optional: show immediately
            if (opts.show === true) {
                show();
            }

            el._popperTip = tip;
            el._popperInstance = popper;
            el._popperCleanup = () => {
                // Remove trigger listeners
                el.removeEventListener('mouseenter', onMouseEnter);
                el.removeEventListener('mouseleave', onMouseLeave);
                el.removeEventListener('focus', onFocus);
                el.removeEventListener('blur', onBlur);
                el.removeEventListener('click', onClick);

                // Remove global listeners
                document.removeEventListener('pointerdown', onDocumentPointerDown, true);
                document.removeEventListener('keydown', onDocumentKeyDown, true);

                // Cleanup DOM & popper
                popper.destroy();
                tip.remove();

                // Restore attrs
                el.removeAttribute('aria-describedby');
                if (el._originalTitle) {
                    el.setAttribute('title', el._originalTitle);
                }
            };
        },

        unmounted(el) {
            if (el._popperCleanup) {
                el._popperCleanup();
            }
        }
    };

    Adzuki.VueDirectives.Tooltip = vPopperTooltip;
}(jQuery, window.Adzuki || {}));